import React, {createContext, useEffect, useRef, useState} from 'react';
import { useUser } from 'hooks';

const PushContext = createContext({
  push: null,
  setPush: ({}: any) => {},
  removeMessage: ({}: any) => {},
  getMessages: () => {},
  wsWeather: null as any,
  wsActiveIotDevice: null as any,
  isAlarmOpen: false,
  openAlarm: () => {},
  closeAlarm: () => {}
});

const PushProvider = ({children}: any) => {
  const { isLogin } = useUser();
  const [socketConnected, setSocketConnected] = useState(false);
  const [items, setItems] = useState([]);
  const [wsWeather, setWsWeather] = useState<any>(null);
  const [wsActiveIotDevice, setWsActiveIotDevice] = useState<any>(null);
  const [isAlarmOpen, setIsAlarmOpen] = useState(false);
  const openAlarm = () => setIsAlarmOpen(true);
  const closeAlarm = () => setIsAlarmOpen(false);
  const webSocketUrl = `${window.location.protocol === 'https:' ? 'wss' : 'ws'}://${window.location.host}/v1/api/ws/message`;
  let ws = useRef(null);
  const shouldReconnect = useRef(false);

  function wsconnect(){
    try{
      // @ts-ignore
      ws.current = new WebSocket(webSocketUrl);
      // @ts-ignore
      ws.current.onopen = () => {
        console.log("connected to " + webSocketUrl);
        setSocketConnected(true);
      };
      // @ts-ignore
      ws.current.onclose = (error: any) => {
        console.log("disconnect from " + webSocketUrl);
        console.log(error);
        if (shouldReconnect.current) {
          setTimeout(function() {
            wsconnect();
          }, 1000);
        }
      };
      // @ts-ignore
      ws.current.onerror = (error: any) => {
        console.log("connection error " + webSocketUrl);
        console.log(error);
      };
      // @ts-ignore
      ws.current.onmessage = (evt: any) => {
        const data = JSON.parse(evt.data);
        if(data){
          if(data.make === "CURRENT_WEATHER"){
            //console.log(data.currentWeather)
            setWsWeather(data.currentWeather)
          }
          if(data.make === "ACTIVE_IOT_DEVICE"){
            //console.log(data.activeIotDevice)
            setWsActiveIotDevice(data.activeIotDevice)
          }
        }
      };
    }catch (e){
      console.error(e)
      if (shouldReconnect.current) {
        setTimeout(function() {
          wsconnect();
        }, 3000);
      }
    }
  }

  useEffect(() => {
    if (!isLogin) {
      shouldReconnect.current = false;
      if (ws.current) {
        // @ts-ignore
        ws.current.close();
      }
      setSocketConnected(false);
      return;
    }

    shouldReconnect.current = true;
    wsconnect();

    return () => {
      console.log("clean up");
      shouldReconnect.current = false;
      // @ts-ignore
      if (ws.current) ws.current.close();
    };
  }, [isLogin]);

  useEffect(() => {
    if(items.length > 0){

      // @ts-ignore
      setPush({isOpen: true, messages:items})
    }
    // @ts-ignore
  },[items])
  function removeMessage(target: any){
    var r = items.filter((item: any) => item.uuid !== target.uuid)
    setItems(r);
    return r;
  }
  function getMessages(){
    return items;
  }
  const [push, setPush] = useState(null);
  const value: any = {push, setPush, items, removeMessage, getMessages, wsWeather, wsActiveIotDevice, isAlarmOpen, openAlarm, closeAlarm};
  return <PushContext.Provider value={value}>{children}</PushContext.Provider>;
};

export {PushContext, PushProvider};
